export const getRankInspectorClientName = (item) => {
  if (item?.cliente?.nome && item.cliente.nome.trim()) {
    return item.cliente.nome.trim()
  }

  if (item?.brand && item.brand.trim()) {
    return item.brand.trim()
  }

  return '-'
}
